import { fetchApi, getApi } from '@coconut/services/apis/utils';

import * as QuestionTypes from '@coconut/constants/questionType';

export const fetchQuestions = ({
  userId,
  statuses,
  searchIds,
  type = QuestionTypes.ALL_QUESTION,
}) =>
  fetchApi(`api/v2/students/${userId}/questions_history`, 'GET', {
    params: {
      statuses,
      subject_ids: searchIds,
      size_per_page: 50,
      type,
    },
  }).then((res) => res);

export const fetchNonLoginQuestions = (id) =>
  getApi(`api/v2/web/questions/${id}`).then((res) => res);



// WEBPACK FOOTER //
// ./src/scenes/Home/services/apis/questions.js